import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Image from 'components/Image';
import Video from 'components/Video';
import styles from './index.scss';

class HeroCarouselMicro extends PureComponent {
  static propTypes = {
    playlist: PropTypes.object,
    compact: PropTypes.bool,
    style: PropTypes.object,
    itemClickListener: PropTypes.func,
  };
  handleItemClick = (index, item) => {
    const { compact, itemClickListener } = this.props;
    if (!compact && item.type === 'a') {
      const el = document.getElementById(item.key);
      if (el) {
        el.click();
      }
    }
    if (itemClickListener) {
      itemClickListener(item);
    }
  };
  renderItem = (item, style, compact) => {
    if (item) {
      const { itemClickListener } = this.props;
      const { assetId, url, mimeType } = item;
      return mimeType.indexOf('video') > -1
        ? this.renderVideo(item, assetId, style, !compact && url)
        : this.renderImage(item, assetId, style, !compact && url, compact && itemClickListener);
    }
    return this.renderImage(null, uniqueId(), style);
  };
  renderImage = (asset, key, style, url, itemClickListener) => {
    const img = (
      <Image
        alt={asset && asset.description}
        src={asset && asset.url?.replace('/basset', '/basset-w600-h313')}
        style={style}
        onClick={itemClickListener}
        tabIndex={itemClickListener && 0}
        className={itemClickListener && styles.container}
      />
    );
    return (url
        ? (
          <a
            href={url}
            id={key}
            key={key}
            target='_blank'
            rel='noopener noreferrer'
          >
            {img}
          </a>
        )
        : (
          <span key={key} tabIndex={itemClickListener && -1} className={itemClickListener && styles.container}>
            {img}
          </span>
        )
    );
  };
  renderVideo = (asset, key, style, url) => {
    let sources = [];
    if (asset.provider && asset.basename) {
      sources = asset.basename;
    } else if (asset.hlsPlaylistUrl) {
      sources = asset.hlsPlaylistUrl?.replace('/basset', '/basset-w600-h313');
    } else {
      if (asset.mp4Url) {
        sources.push({
          src: asset.mp4Url,
          type: 'video/mp4',
        });
      }
      if (asset.webmUrl) {
        sources.push({
          src: asset.webmUrl,
          type: 'video/webm',
        });
      }
    }
    return (
      <Video
        key={key}
        href={url}
        sources={sources}
        style={style}
      />
    );
  };

  render() {
    const { playlist, compact, style } = this.props;
    return this.renderItem(playlist, style, compact);
  }
}

export default HeroCarouselMicro;
